/**
 * printTicket — versión sin await internos.
 * window.open debe ejecutarse sincrónicamente o en setTimeout corto.
 */
export const printTicket = (sale) => {
  try {
    console.log("🧾 SALE RECIBIDO:", sale);

    const settings = sale.settings || {};

    /* ── ORDER NUMBER ── */
    const getOrderNumber = () => {
      const raw = sale.order_number ?? sale.orderNumber ?? sale.id ?? null;
      if (raw === null || raw === undefined || raw === "") return "----";
      const str = String(raw);
      if (str.includes("-")) return str;
      return "ORD-" + str.padStart(6, "0");
    };

    const items = sale.items || sale.products || sale.details || [];

    const getUserName = () => (
      sale.employee_name?.trim() ||
      sale.user_name ||
      sale.cashier ||
      "N/A"
    );

    const ticketWidth = settings.ticket_width == 58 ? '220px' : '300px';
    const date        = new Date().toLocaleString();

    const saleData = {
      id:             getOrderNumber(),
      items,
      total:          sale.total          ?? 0,
      payment_method: sale.payment_method || "N/A",
      amount_paid:    sale.amount_paid    ?? null,
      user_name:      getUserName(),
      order_name:     sale.order_name     || null,
      // FIX: datos loyalty
      loyalty_customer: sale.loyalty_customer || null,
      loyalty_discount: sale.loyalty_discount || 0,
      points_earned:    sale.points_earned    || 0,
    };

    /* ── CÁLCULOS ── */
    const subtotal = items.reduce((acc, item) => {
      const price = Number(item.price || 0);
      const qty   = Number(item.quantity || 1);
      return acc + (item.price_without_vat || price / 1.16) * qty;
    }, 0);

    const total = items.reduce((acc, item) => {
      return acc + Number(item.price || 0) * Number(item.quantity || 1);
    }, 0);

    const tax = total - subtotal;

    // FIX: total final ya con descuento loyalty
    const finalTotal = Math.max(0, total - saleData.loyalty_discount);

    const isInApp  = /wv|WebView|Android/i.test(navigator.userAgent) || !!window.ReactNativeWebView;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    /* ── HTML ── */
    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Ticket</title>
  <style>
    body { margin:0; padding:10px; background:white; font-family:monospace; }
    .center { text-align:center; }
    .row { display:flex; justify-content:space-between; font-size:14px; }
    .small { font-size:12px; }
    .big { font-size:20px; font-weight:bold; margin:5px 0; }
    hr { border:none; border-top:1px dashed black; margin:6px 0; }
    .logo { max-width:100%; margin-bottom:5px; }
    .qr { margin-top:10px; }
    .loyalty-box { background:#f0f9f0; border:1px dashed #58735A; border-radius:6px; padding:6px 10px; margin:6px 0; font-size:12px; }
    @media print { button { display:none; } }
  </style>
</head>
<body>
<div style="width:${ticketWidth}; margin:auto;">

  <div class="center">
    ${settings.logo ? `<img src="${settings.logo}" class="logo"/>` : ""}
    <h3 style="margin:4px 0;">${settings.business_name || 'CAFETERIA'}</h3>
    ${settings.branch_name ? `<p class="small">${settings.branch_name}</p>` : ""}
    ${settings.rfc        ? `<p class="small">RFC: ${settings.rfc}</p>`    : ""}
    <p class="small">${settings.address || ''}</p>
    <p class="small">${settings.phone   || ''}</p>
    <p class="small">${date}</p>
  </div>

  <hr/>

  ${settings.show_order_number ? `
  <div class="center big">
    ORDEN #${saleData.id}
    ${saleData.order_name ? `<div style="font-size:14px;font-weight:normal;">${saleData.order_name}</div>` : ''}
  </div>
  <hr/>
  ` : ""}

  ${items.map(item => {
    const name  = item.name || item.product_name || 'Producto';
    const price = Number(item.price || 0);
    const qty   = Number(item.quantity || 1);
    const variantLabel = item.variantLabel ||
      (Array.isArray(item.variants) && item.variants.length > 0
        ? item.variants.map(v => v.variant_name || v.name).filter(Boolean).join(', ')
        : '');
    const note = item.note || '';
    return `
      <div class="row">
        <span>${name} x${qty}</span>
        <span>$${(price * qty).toFixed(2)}</span>
      </div>
      ${variantLabel ? `<div class="small" style="color:#555;padding-left:8px;">↳ ${variantLabel}</div>` : ''}
      ${note        ? `<div class="small" style="color:#555;padding-left:8px;font-style:italic;">Nota: ${note}</div>` : ''}
    `;
  }).join("")}

  <hr/>

  <div class="row"><span>Subtotal</span><span>$${subtotal.toFixed(2)}</span></div>
  <div class="row"><span>IVA (16%)</span><span>$${tax.toFixed(2)}</span></div>

  ${saleData.loyalty_discount > 0 ? `
  <div class="row" style="color:#3a7a3a;">
    <span>Descuento puntos</span>
    <span>-$${Number(saleData.loyalty_discount).toFixed(2)}</span>
  </div>
  ` : ""}

  <hr/>

  <div class="row"><strong>TOTAL</strong><strong>$${finalTotal.toFixed(2)}</strong></div>

  <hr/>

  <p class="small">Pago: ${saleData.payment_method}</p>

  ${saleData.payment_method === 'Efectivo' && saleData.amount_paid ? `
  <p class="small">Pagó: $${parseFloat(saleData.amount_paid).toFixed(2)}</p>
  <p class="small">Cambio: $${Math.max(0, saleData.amount_paid - finalTotal).toFixed(2)}</p>
  ` : ""}

  ${settings.show_cashier ? `<p class="small">Cajero: ${saleData.user_name}</p>` : ""}

  ${saleData.loyalty_customer ? `
  <hr/>
  <div class="loyalty-box">
    <div>⭐ Cliente: <strong>${saleData.loyalty_customer.name}</strong></div>
    ${saleData.points_earned > 0
      ? `<div>Puntos ganados: <strong>+${saleData.points_earned}</strong></div>`
      : ''}
    <div>Saldo total: <strong>${
      (saleData.loyalty_customer.points || 0) + saleData.points_earned
    } pts</strong></div>
  </div>
  ` : ""}

  <hr/>

  ${settings.show_qr && settings.qr_url ? `
  <div class="center qr">
    <img src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(settings.qr_url + '?ticket=' + saleData.id)}" />
    <p class="small">Escanea para factura o feedback</p>
  </div>
  <hr/>
  ` : ""}

  <p class="center small">${settings.footer_message || 'Gracias por su compra'}</p>

</div>
</body>
</html>`;

    /* ── KODULAR / MÓVIL ── */
    if (isMobile || isInApp) {
      const encoded = encodeURIComponent(html);
      const url     = `https://lezen.site/ticket_viewer.html?data=${encoded}`;

      console.log("🌍 Abriendo en navegador externo");

      setTimeout(() => {
        let opened = window.open(url, "_system");
        if (!opened) {
          console.warn("⚠️ _system falló, usando _blank");
          opened = window.open(url, "_blank");
        }
        if (!opened) {
          console.warn("⚠️ window.open bloqueado, usando location.href");
          window.location.href = url;
        }
      }, 800);

      return;
    }

    /* ── DESKTOP ── */
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;border:0;opacity:0;';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(html);
    doc.close();

    setTimeout(() => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        console.error("❌ Error al llamar print():", e);
      }
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 2000);
    }, 600);

  } catch (error) {
    console.error("❌ Error imprimiendo ticket:", error);
  }
};